import { Button, CircularProgress, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { getOpcionesProyectos, getProyectos, opcinesMenu } from '../../services/apis';

import { ProyectoCard } from './ProyectoCard';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { OpcionesMenuFunc } from '../../utils/componentes-utiles/OpcionesMenuFunc';
import { FormCrearProyecto } from './FormCrearProyecto';

//mapa de iconos


export const Proyectos = () => {
    // Global
    const navigate = useNavigate();

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [proyectos, setProyecto] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [open, setOpen] = useState(false);
    const [opcionesDialog, setOpcionesDialog] = useState([]);
    // Cargar opciones menú principal

    const cargarOpcionesAdm = async () => {
        try {
            const response = await getOpcionesProyectos();
            setOpciones(response.data.opcionesproyectos);
            setOpcionesDialog(response.data.opcionesdialogproyectos);


            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };
    const cargarOpciones = async () => {
        try {
            const response = await getProyectos();
            setProyecto(response.data)
            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);

        }
    };

    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                // setOpenEdit(true);
                setOpen(!open);

                // Lógica para la opción 1
                break;


            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }

    useEffect(() => {
        cargarOpciones();
        cargarOpcionesAdm();
    }, []);

    return (
        <div className='menu-back fade-in2'>
            <SubHeader />
            <h1>PROYECTOS</h1>
            {opciones && (
                <OpcionesMenuFunc opciones={opciones} handleEvent={handleEvent}></OpcionesMenuFunc>
            )}
            {
                !loaded && (
                    <CircularProgress />
                )
            }
            <div className='menu-principal fade-in-2'>
                <Grid xs={12} container spacing={3} justifyContent="center">
                    {loaded && proyectos.length > 0 && (
                        proyectos.map(opcion => (
                            <ProyectoCard key={opcion.id} data={opcion} />
                        ))
                    )}
                </Grid>
            </div>
            {open && (
                <FormCrearProyecto
                    open={open}
                    setOpen={setOpen}
                    cargarProyectos={cargarOpciones}
                    opciones={opcionesDialog}
                    setOpciones={setOpcionesDialog}
                />
            )}
        </div >
    )
}
